import { render, staticRenderFns } from "./TextAlignmentsDesktop.vue?vue&type=template&id=15d79660&scoped=true&"
import script from "./TextAlignmentsDesktop.vue?vue&type=script&lang=ts&"
export * from "./TextAlignmentsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./TextAlignmentsDesktop.vue?vue&type=style&index=0&id=15d79660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d79660",
  null
  
)

export default component.exports